import PendingAssetEditor from "../../shared/PendingAssetEditor";
import React, { useEffect, useState } from "react";
import axios from "axios";
import PendingAssetDeleteButton from "../../shared/PendingAssetDeleteButton";
import "./pendingAssetdetails.css";
import { Link ,useNavigate } from "react-router-dom";
import { departmentCodes } from "../../Data/departmentcode";
import { companyCodes } from "../../Data/Companycode";
import useAutoRefresh from "../../../hooks/useAutoRefresh";
import useDebouncedValue from "../../../hooks/useDebouncedValue";
import AssetPagination from "../../shared/AssetPagination";

const PendingComAssetDetails = () => {
  const [assetRegisterDetails, setAssetRegisterDetails] = useState([]);
  const [transferAssetDetails, setTransferAssetDetails] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchQuery1, setSearchQuery1] = useState("");
  const [searchQuery2, setSearchQuery2] = useState("");
  const [assetDetailsView, setAssetDetailsView] = useState(
    "pendingregisterAsset"
  );
  const [editAsset, setEditAsset] = useState(null);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({ total: 0, totalPages: 1 });
  const serverSearch = useDebouncedValue([searchQuery, searchQuery1, searchQuery2].filter(Boolean).join(" "));
  useEffect(() => setPage(1), [serverSearch, assetDetailsView]);

  useEffect(() => {
    if (assetDetailsView === "pendingregisterAsset") {
      //fetchRegisterAssets();
      fetchAssets();
    } else {
      fetchTransferAssets();
    }
  }, [assetDetailsView, page, serverSearch]);

  /* const fetchRegisterAssets = () => {
    axios
      .get(
        "/api/PendingAssetRegisterDetails/getPendingAssetDetails"
      )
      .then((response) => setAssetRegisterDetails(response.data))
      .catch((error) =>
        console.error("Error fetching register asset details:", error)
      );
  };*/

  /*useEffect(() => {
        fetchAssets();
    }, []);*/

  const fetchAssets = async () => {
    const currentUser = JSON.parse(localStorage.getItem("currentUser")); // Get logged-in user details

    if (!currentUser || !currentUser.username) {
      console.error("User data not found or username missing");
      return;
    }

    try {
      // Fetch all registered users
      const userResponse = await axios.get(
        "/api/users/getallUsers"
      );
      const allUsers = userResponse.data;

      // Find the user that matches the current username
      const userData = allUsers.find(
        (user) => user.username === currentUser.username
      );

      if (!userData || !userData.companyName) {
        console.error("User company details not found");
        return;
      }

      // Fetch asset details
      const assetResponse = await axios.get(
        "/api/PendingAssetRegisterDetails/getPendingAssetDetails",
        { params: { paginated: true, page, limit: 100, search: serverSearch, company: userData.companyName } }
      );
      const filteredAssets = assetResponse.data.assets.filter(
        (asset) => asset.company === userData.companyName
      );

      setAssetRegisterDetails(filteredAssets); // Only set assets that match the company
      setPagination(assetResponse.data.pagination);
    } catch (error) {
      console.error("Error fetching asset details or user data:", error);
    }
  };

  /* const fetchTransferAssets = () => {
    axios
      .get(
        "/api/transfer/getPendingTransferAssetDetails"
      )
      .then((response) => setTransferAssetDetails(response.data))
      .catch((error) =>
        console.error("Error fetching transfer asset details:", error)
      );
  };*/

  const fetchTransferAssets = async () => {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));

    if (!currentUser || !currentUser.username) {
      console.error("User data not found or username missing");
      return;
    }

    try {
      const userResponse = await axios.get(
        "/api/users/getallUsers"
      );
      const allUsers = userResponse.data;

      const userData = allUsers.find(
        (user) => user.username === currentUser.username
      );

      if (!userData || !userData.companyName) {
        console.error("User company details not found");
        return;
      }

      const assetResponse = await axios.get(
        "/api/transfer/getPendingTransferAssetDetails",
        { params: { paginated: true, page, limit: 100, search: serverSearch, company: userData.companyName } }
      );

      const filteredTransferAssets = assetResponse.data.assets.filter(
        (asset) => asset.company === userData.companyName
      );

      setTransferAssetDetails(filteredTransferAssets);
      setPagination(assetResponse.data.pagination);
    } catch (error) {
      console.error("Error fetching asset details or user data:", error);
    }
  };

  useAutoRefresh(() => {
    if (assetDetailsView === "pendingregisterAsset") {
      fetchAssets();
    } else {
      fetchTransferAssets();
    }
  });

  const handleDetailsView = (e) => {
    setAssetDetailsView(e.target.value);
  };

  const handleEditClick = (asset) => {
    setEditAsset(asset);
  };

   

  // AUTO GENERATE TRACKING ID WHEN SERIAL NUMBER CHANGES
 

  const queryMatch = (query, asset) =>
    (asset.name?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.company?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.department?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.category?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.type?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.assetName?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.assetUserName?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.assetModel?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.serialNumber?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.trackingId?.toLowerCase() || "").includes(query.toLowerCase()) ||
     (asset.assetUpdateDate?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.assetTransferDate?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.subComponent?.toLowerCase() || "").includes(
      query.toLowerCase()
    )||(asset.conditionType?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.invoiceDetails?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.specialNote?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.warranty?.toLowerCase() || "").includes(query.toLowerCase()) ||
    (asset.supplierName?.toLowerCase() || "").includes(query.toLowerCase());

  const filteredAssets =
    assetDetailsView === "pendingregisterAsset"
      ? assetRegisterDetails.filter((asset) =>
          [searchQuery, searchQuery1, searchQuery2].every(
            (query) => !query || queryMatch(query, asset)
          )
        )
      : transferAssetDetails.filter((asset) =>
          [searchQuery, searchQuery1, searchQuery2].every(
            (query) => !query || queryMatch(query, asset)
          )
        );


        const handleHandoverNote = (asset) => {
            navigate("/HandoverNote", { state: { asset } });
          };
        
          const navigate = useNavigate();


          const exportToExcel = () => {
  if (!filteredAssets || filteredAssets.length === 0) {
    alert("No filtered data available to export!");
    return;
  }

  const XLSX = require("xlsx");

  // REMOVE unwanted fields for each filtered asset
  const cleanedData = filteredAssets.map(
    ({
      _id,
     computerComponents,
      createdAt,
      updatedAt,
      __v,
      ...rest
    }) => rest
  );

  // Convert to worksheet
  const ws = XLSX.utils.json_to_sheet(cleanedData);

  // Auto column width
  const colWidths = Object.keys(cleanedData[0]).map((key) => ({
    wch: 20,
  }));
  ws['!cols'] = colWidths;

  // Create workbook
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Filtered Assets");

  // Export
  XLSX.writeFile(wb, "Filtered_Asset_Details.xlsx");
};



  return (
    <div className="row details2">
      <div className="col-md-14">
        <h1 className="assethead">Pending Asset Details</h1>

        <p>
          <Link to="/CompanyDashBord">Dashboard</Link> /
          <Link to="/ComPendingAsset"> Pending Asset Details</Link>
        </p>

        <button className="btnExcel" onClick={exportToExcel}>
  Export Filtered Assets to Excel
</button>

        {/* VIEW SWITCH */}
        <div className="radio-toggle-container mb-4">
          <label
            className={`radio-option1 ${
              assetDetailsView === "pendingregisterAsset" ? "active" : ""
            }`}
          >
            <input
              type="radio"
              value="pendingregisterAsset"
              name="view"
              checked={assetDetailsView === "pendingregisterAsset"}
              onChange={handleDetailsView}
            />
            Pending Register Asset
          </label>

          <label
            className={`radio-option1 ${
              assetDetailsView === "pendingtransferasset" ? "active" : ""
            }`}
          >
            <input
              type="radio"
              value="pendingtransferasset"
              name="view"
              checked={assetDetailsView === "pendingtransferasset"}
              onChange={handleDetailsView}
            />
            Pending Transfer Asset
          </label>
        </div>

        {/* SEARCH BOXES */}
        <div className="row">
          <div className="col-md-4 col-12 mb-2">
            <input
              className="form-control"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          <div className="col-md-4 col-12 mb-2">
            <input
              className="form-control"
              placeholder="Search by category/type/name..."
              value={searchQuery1}
              onChange={(e) => setSearchQuery1(e.target.value)}
            />
          </div>

          <div className="col-md-4 col-12 mb-2">
            <input
              className="form-control"
              placeholder="Search by model/serial/tracking..."
              value={searchQuery2}
              onChange={(e) => setSearchQuery2(e.target.value)}
            />
          </div>
        </div>

        {/* TABLE RESPONSIVE WRAPPER */}
        <div className="table-responsive mt-3">
          <table className="table table-bordered table-light custom_table">
            <thead className="thead-dark">
              <tr>
                <th>Register Name</th>
                <th>Company</th>
                <th>Department</th>
                <th>Category</th>
                <th>Condition Type</th>
                <th>Type</th>
                <th>Asset</th>
                <th>EPF No & Recipient Name</th>
                <th>Model</th>
                <th>Register Date</th>
                {assetDetailsView === "pendingtransferasset" && (
                  <th>Transfer Date</th>
                )}
                <th>Serial</th>
                <th>Tracking ID</th>
                <th>Price</th>
                <th>Note</th>
                <th>Components</th>
                <th>Asset Image</th>
              <th>Invoice Image</th>
              <th>Warranty</th>
              <th>Supplier Name</th>
              <th>Invoice Number</th>
              <th>Purchase Date</th>
              <th>Handover Note</th>
                <th>Status</th>
                {(assetDetailsView === "pendingregisterAsset" ||
                  assetDetailsView === "pendingtransferasset") && <th>Edit</th>}
              </tr>
            </thead>

            <tbody>
              {filteredAssets.length > 0 ? (
                filteredAssets.map((asset) => (
                  <tr key={asset._id}>
                    <td>{asset.name}</td>
                    <td>{asset.company}</td>
                    <td>{asset.department}</td>
                    <td>{asset.category}</td>
                    <td>{asset.conditionType}</td>
                    <td>{asset.type}</td>
                    <td>{asset.assetName}</td>
                    <td>{asset.assetUserName}</td>
                    <td>{asset.assetModel}</td>
                    <td>{asset.assetUpdateDate}</td>
                    {assetDetailsView === "pendingtransferasset" && (
                      <td>{asset.assetTransferDate || "N/A"}</td>
                    )}
                    <td>{asset.serialNumber}</td>
                    <td>{asset.trackingId}</td>
                    <td>{asset.assetprice}</td>
                    <td>{asset.specialNote}</td>
                    <td>{asset.subComponent}</td>
                    <td>
                      {asset.assetImageURL ? (
                        <a
                          href={asset.assetImageURL}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Image
                        </a>
                      ) : (
                        "No Image"
                      )}
                    </td>

                    <td>
                      {asset.invoiceFileURL ? (
                        <a
                          href={asset.invoiceFileURL}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Invoice
                        </a>
                      ) : (
                        "No Invoice"
                      )}
                    </td>
                      <td>{asset.warranty}</td>
                      <td>{asset.supplierName}</td>
                      <td>{asset.invoiceDetails}</td>
                      <td>{asset.purchaseDate}</td>
                       <td>
                      <button
                        className="handoverbtn"
                        onClick={() => handleHandoverNote(asset)}
                      >
                        <i className="fas fa-download"></i> Handover
                      </button>
                    </td>
                    <td>
                      <button className="status">Pending</button>
                    </td>
                    <td>
                      {(assetDetailsView === "pendingregisterAsset" ||
                        assetDetailsView === "pendingtransferasset") && (
                        <><button
                          className="editstsatus"
                          onClick={() => handleEditClick(asset)}
                        >
                          Edit
                        </button><PendingAssetDeleteButton
                            asset={asset}
                            isTransfer={assetDetailsView === "pendingtransferasset"}
                            onDeleted={(id) => assetDetailsView === "pendingregisterAsset"
                              ? setAssetRegisterDetails((items) => items.filter((item) => item._id !== id))
                              : setTransferAssetDetails((items) => items.filter((item) => item._id !== id))} /></>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="15" className="text-center">
                    No matching asset data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <AssetPagination page={pagination.page || page} totalPages={pagination.totalPages} total={pagination.total} onPageChange={setPage} />
        </div>

        {/* EDIT MODAL */}
        {editAsset && <PendingAssetEditor key={editAsset._id} asset={editAsset} onClose={() => setEditAsset(null)} onSaved={updated => { setEditAsset(null); fetchAssets(); }} />}
      </div>
    </div>
  );
};

export default PendingComAssetDetails;
